import { NgModule } from '@angular/core';
import { IConfig, NgxMaskModule } from "ngx-mask";
import { TranslateModule } from "@ngx-translate/core";
import { ToastrModule } from "ngx-toastr";


// @ts-ignore
export const maskOptions: Partial<IConfig> = {
    validation: false,
};

export const toastrOptions: any = {
    timeOut: 5000,
    positionClass: 'toast-top-right',
    preventDuplicates: false,
};

// This is here just to enforce structure for when it's needed
@NgModule({
    declarations: [],
    imports: [
        NgxMaskModule,
        TranslateModule,
        NgxMaskModule.forRoot(maskOptions),
        ToastrModule.forRoot(toastrOptions)
    ],
    exports: [
        NgxMaskModule,
        TranslateModule,
        ToastrModule
    ],
    providers: []
})
export class NGXLibraryModule {


}
